import React, { Component } from 'react';
import './HomeSponsor.scss';
import { fetchSponsorsList } from '../../Actions/SponsorsList';
import { connect } from 'react-redux';

class SponsorSection extends Component {
  render() {
    const sponsors = () => {
      return this.props.sponsorsList.map((sponsor, index) => {
        return (
          <div className="col-sm-12 text-center" key={index}>
            <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
              {sponsor.label}
            </a>
          </div>
        );
      });
    };

    return (
      <div className="row homeSponsor">
        <div className="col-md-12 text-center">
          <h2 className="section-header">Sponsoren</h2>
          <p className="section-header-subtitle">
            {'mit freundlicher unterstützung von:'}
          </p>
        </div>
        <div className="col-md-12 text-center">{sponsors()}</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    sponsorsList: state.sponsorsListReducer.list
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSponsorsList: () => dispatch(fetchSponsorsList())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SponsorSection);



// WEBPACK FOOTER //
// ./src/Containers/HomeElements/HomeSponsor.js